<template>
	<baidu-map class="contact_map" ak="WpooRa5eSI7pPexkake6OafmKCec6RSQ"
	           :center="center"
	           :zoom="zoom"
	           :scroll-wheel-zoom="true"
	           @ready="mapReady">
		<bm-marker :position="center" :dragging="true" @click="infoWindowOpen">
			<bm-info-window :show="show" @close="infoWindowClose" @open="infoWindowOpen" style="width: 340px; height: 95px;">
				<h3 class="title">联系我们</h3>
				<p class="text">地址：{{ data.address }}</p>
				<p class="text">电话：{{ data.phone }}</p>
			</bm-info-window>
		</bm-marker>
	</baidu-map>
</template>

<script>
import {BaiduMap, BmAutoComplete, BmMarker, BmInfoWindow} from "vue-baidu-map/components";

export default {
	name: "index",
	components: {
		BaiduMap,
		BmAutoComplete,
		BmMarker,
		BmInfoWindow,
	},
	props: {
		data: {
			type: Object,
			default: () => {
				return {}
			}
		}
	},
	data() {
		return {
			BMap: null,
			center: {
				lng: 114.527144,
				lat: 38.027385,
			},
			zoom: 17,
			show: true,
		}
	},
	methods: {
		mapReady({BMap, map}) {

		},

		infoWindowClose () {
			this.show = false
		},
		infoWindowOpen () {
			this.show = true
		}
	}
}
</script>

<style lang="less" scoped>
.contact_map {
	width: 100%;
	height: 400px;
	margin-top: 40px;

	.title {
		font-size: 15px;
		color: #CC5522;
		margin-bottom: 10px;
	}

	.text {
		font-size: 14px;
		color: #000000;
		line-height: 1.6;
	}
}
</style>
